import {
  loadLocations,
  saveLocation,
  loadLessons,
  saveLesson,
  loadSchedules,
  saveSchedule
} from "../../firebaseCalls";
import { getCoordinates } from "../../lib/here";

export const getCurrentSite = () => {
  const host = window.location.hostname;
  let site = "Auckland";
  if (host.indexOf("auckland") >= 0) {
    site = "Auckland";
  }
  return site;
};

const DATA_LOAD_LOCATIONS_REQUEST = "DATA_LOAD_LOCATIONS_REQUEST";
const DATA_LOAD_LOCATIONS_SUCCESS = "DATA_LOAD_LOCATIONS_SUCCESS";
const DATA_LOAD_LOCATIONS_ERROR = "DATA_LOAD_LOCATIONS_ERROR";

const DATA_SAVE_LOCATION_REQUEST = "DATA_SAVE_LOCATION_REQUEST";
const DATA_SAVE_LOCATION_SUCCESS = "DATA_SAVE_LOCATION_SUCCESS";
const DATA_SAVE_LOCATION_ERROR = "DATA_SAVE_LOCATION_ERROR";

const DATA_ADD_LOCATION_REQUEST = "DATA_ADD_LOCATION_REQUEST";
const DATA_ADD_LOCATION_SUCCESS = "DATA_ADD_LOCATION_SUCCESS";
const DATA_ADD_LOCATION_ERROR = "DATA_ADD_LOCATION_ERROR";

const DATA_LOAD_LESSONS_REQUEST = "DATA_LOAD_LESSONS_REQUEST";
const DATA_LOAD_LESSONS_SUCCESS = "DATA_LOAD_LESSONS_SUCCESS";
const DATA_LOAD_LESSONS_ERROR = "DATA_LOAD_LESSONS_ERROR";

const DATA_SAVE_LESSON_REQUEST = "DATA_SAVE_LESSON_REQUEST";
const DATA_SAVE_LESSON_SUCCESS = "DATA_SAVE_LESSON_SUCCESS";
const DATA_SAVE_LESSON_ERROR = "DATA_SAVE_LESSON_ERROR";

const DATA_ADD_LESSON_REQUEST = "DATA_ADD_LESSON_REQUEST";
const DATA_ADD_LESSON_SUCCESS = "DATA_ADD_LESSON_SUCCESS";
const DATA_ADD_LESSON_ERROR = "DATA_ADD_LESSON_ERROR";

const DATA_LOAD_SCHEDULE_REQUEST = "DATA_LOAD_SCHEDULE_REQUEST";
const DATA_LOAD_SCHEDULE_SUCCESS = "DATA_LOAD_SCHEDULE_SUCCESS";
const DATA_LOAD_SCHEDULE_ERROR = "DATA_LOAD_SCHEDULE_ERROR";

const DATA_SAVE_SCHEDULE_REQUEST = "DATA_SAVE_SCHEDULE_REQUEST";
const DATA_SAVE_SCHEDULE_SUCCESS = "DATA_SAVE_SCHEDULE_SUCCESS";
const DATA_SAVE_SCHEDULE_ERROR = "DATA_SAVE_SCHEDULE_ERROR";

const DATA_ADD_SCHEDULE_REQUEST = "DATA_ADD_SCHEDULE_REQUEST";
const DATA_ADD_SCHEDULE_SUCCESS = "DATA_ADD_SCHEDULE_SUCCESS";
const DATA_ADD_SCHEDULE_ERROR = "DATA_ADD_SCHEDULE_ERROR";

export const loadSchedulesAction = () => {
  return async dispatch => {
    dispatch({ type: DATA_LOAD_SCHEDULE_REQUEST });
    try {
      const schedules = await loadSchedules();
      dispatch({ type: DATA_LOAD_SCHEDULE_SUCCESS, schedules });
    } catch (e) {
      console.log(e);
      dispatch({ type: DATA_LOAD_SCHEDULE_ERROR, error: e });
    }
  };
};

export const saveScheduleAction = (loc, field) => {
  return async dispatch => {
    dispatch({ type: DATA_SAVE_SCHEDULE_REQUEST, field });
    try {
      const schedule = await saveSchedule(loc);
      dispatch({ type: DATA_SAVE_SCHEDULE_SUCCESS, schedule });
    } catch (e) {
      console.log(e);
      dispatch({ type: DATA_SAVE_SCHEDULE_ERROR, error: e });
    }
  };
};

export const addScheduleAction = locs => {
  return async dispatch => {
    dispatch({ type: DATA_ADD_SCHEDULE_REQUEST });
    try {
      const schedules = await Promise.all(
        locs.map(async l => {
          return await saveSchedule(l);
        })
      );
      dispatch({ type: DATA_ADD_SCHEDULE_SUCCESS, schedules });
    } catch (e) {
      console.log(e);
      dispatch({ type: DATA_ADD_SCHEDULE_ERROR, error: e });
    }
  };
};

export const loadLocationsAction = () => {
  return async dispatch => {
    dispatch({ type: DATA_LOAD_LOCATIONS_REQUEST });
    try {
      const locations = await loadLocations();
      dispatch({ type: DATA_LOAD_LOCATIONS_SUCCESS, locations });
      const lessons = await loadLessons();
      dispatch({ type: DATA_LOAD_LESSONS_SUCCESS, lessons });
    } catch (e) {
      console.log(e);
      dispatch({ type: DATA_LOAD_LOCATIONS_ERROR, error: e });
    }
  };
};

export const saveLocationAction = (loc, field) => {
  return async dispatch => {
    dispatch({ type: DATA_SAVE_LOCATION_REQUEST, field });
    try {
      if (field === "address") {
        const coords = await getCoordinates(
          loc.address + " , " + getCurrentSite()
        );
        const location = await saveLocation({ ...loc, coords });
        dispatch({ type: DATA_SAVE_LOCATION_SUCCESS, location });
      } else {
        const location = await saveLocation(loc);
        dispatch({ type: DATA_SAVE_LOCATION_SUCCESS, location });
      }
    } catch (e) {
      console.log(e);
      dispatch({ type: DATA_SAVE_LOCATION_ERROR, error: e });
    }
  };
};

export const addLocationAction = loc => {
  return async dispatch => {
    dispatch({ type: DATA_ADD_LOCATION_REQUEST });
    try {
      const location = await saveLocation(loc);
      dispatch({ type: DATA_ADD_LOCATION_SUCCESS, location });
    } catch (e) {
      console.log(e);
      dispatch({ type: DATA_ADD_LOCATION_ERROR, error: e });
    }
  };
};

export const loadLessonsAction = () => {
  return async dispatch => {
    dispatch({ type: DATA_LOAD_LESSONS_REQUEST });
    try {
      const lessons = await loadLessons();
      dispatch({ type: DATA_LOAD_LESSONS_SUCCESS, lessons });
    } catch (e) {
      console.log(e);
      dispatch({ type: DATA_LOAD_LESSONS_ERROR, error: e });
    }
  };
};

export const saveLessonAction = (loc, field) => {
  return async dispatch => {
    dispatch({ type: DATA_SAVE_LESSON_REQUEST, field });
    try {
      const lesson = await saveLesson(loc);
      dispatch({ type: DATA_SAVE_LESSON_SUCCESS, lesson });
    } catch (e) {
      console.log(e);
      dispatch({ type: DATA_SAVE_LESSON_ERROR, error: e });
    }
  };
};

export const addLessonAction = loc => {
  return async dispatch => {
    dispatch({ type: DATA_ADD_LESSON_REQUEST });
    try {
      const lesson = await saveLesson(loc);
      dispatch({ type: DATA_ADD_LESSON_SUCCESS, lesson });
    } catch (e) {
      console.log(e);
      dispatch({ type: DATA_ADD_LESSON_ERROR, error: e });
    }
  };
};
const INIT_STATE = {};

export const dataReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DATA_LOAD_SCHEDULE_REQUEST:
      return { ...state, loading: true };
    case DATA_LOAD_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        schedules: action.schedules
      };
    case DATA_LOAD_SCHEDULE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case DATA_SAVE_SCHEDULE_REQUEST:
      return {
        ...state,
        saving: action.field || true
      };
    case DATA_SAVE_SCHEDULE_SUCCESS:
      return {
        ...state,
        saving: false,
        schedules: state.schedules.map(l =>
          l.id === action.schedule.id ? action.schedule : l
        )
      };
    case DATA_SAVE_SCHEDULE_ERROR:
      return {
        ...state,
        saving: false,
        error: action.error
      };
    case DATA_ADD_SCHEDULE_REQUEST:
      return {
        ...state,
        saving: true
      };
    case DATA_ADD_SCHEDULE_SUCCESS:
      return {
        ...state,
        saving: false,
        schedules: state.schedules.concat(action.schedules)
      };
    case DATA_ADD_SCHEDULE_ERROR:
      return {
        ...state,
        saving: false,
        error: action.error
      };
    case DATA_LOAD_LOCATIONS_REQUEST:
      return { ...state, loading: true };
    case DATA_LOAD_LOCATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        locations: action.locations
      };
    case DATA_LOAD_LOCATIONS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case DATA_SAVE_LOCATION_REQUEST:
      return {
        ...state,
        saving: action.field || true
      };
    case DATA_SAVE_LOCATION_SUCCESS:
      return {
        ...state,
        saving: false,
        locations: state.locations.map(l =>
          l.id === action.location.id ? action.location : l
        )
      };
    case DATA_SAVE_LOCATION_ERROR:
      return {
        ...state,
        saving: false,
        error: action.error
      };
    case DATA_ADD_LOCATION_REQUEST:
      return {
        ...state,
        saving: true
      };
    case DATA_ADD_LOCATION_SUCCESS:
      return {
        ...state,
        saving: false,
        locations: state.locations.concat([action.location])
      };
    case DATA_ADD_LOCATION_ERROR:
      return {
        ...state,
        saving: false,
        error: action.error
      };
    case DATA_LOAD_LESSONS_REQUEST:
      return { ...state, loading: true };
    case DATA_LOAD_LESSONS_SUCCESS:
      return {
        ...state,
        loading: false,
        lessons: action.lessons
      };
    case DATA_LOAD_LESSONS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case DATA_SAVE_LESSON_REQUEST:
      return {
        ...state,
        saving: action.field || true
      };
    case DATA_SAVE_LESSON_SUCCESS:
      return {
        ...state,
        saving: false,
        lessons: state.lessons.map(l =>
          l.id === action.lesson.id ? action.lesson : l
        )
      };
    case DATA_SAVE_LESSON_ERROR:
      return {
        ...state,
        saving: false,
        error: action.error
      };
    case DATA_ADD_LESSON_REQUEST:
      return {
        ...state,
        saving: true
      };
    case DATA_ADD_LESSON_SUCCESS:
      return {
        ...state,
        saving: false,
        lessons: state.lessons.concat([action.lesson])
      };
    case DATA_ADD_LESSON_ERROR:
      return {
        ...state,
        saving: false,
        error: action.error
      };
    default:
      return state;
  }
};

export const isLoading = state => state.data.loading;
export const isSaving = state => state.data.saving;
export const getLocations = state => state.data.locations;
export const getLessons = state => state.data.lessons;
export const getSchedules = state => state.data.schedules;
